import { observable } from "mobx";
import { Expose } from "class-transformer";

export default class RspRegistrationStep1 {
  @observable
  email: string;

  @observable
  @Expose({ name: "sap_notice" })
  sapNotice?: string;
}
